import React from 'react';
import { Route, Routes } from "react-router-dom";
import HomePage from '../Pages/homePage';
import AboutPage from '../Pages/aboutPage';
import FloorSelectionPage from '../Pages/floorSelectionPage';
import AvailabilityPage from '../Pages/AvailabilityPage';
import UnitSelectionPage from '../Pages/unitSelectionPage';
import UnitDetailsPage from '../Pages/unitDetailsPage';
import LocationPage from '../Pages/locationPage';
import VirtualTourPage from '../Pages/virtualTourPage';
import GalleryMasterPage from '../Pages/galleryMasterPage';
import GalleryInternalPage from '../Pages/galleryInternalPage';
import VideosPage from '../Pages/videosPage';

const RoutesPage = () => {
    return (
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/availability" element={<AvailabilityPage />} />
            <Route path="/floor-selection" element={<FloorSelectionPage />} />
            <Route path="/unit-selection/:floor" element={<UnitSelectionPage/>} />
            <Route path="/unit-lay-out/:floor/:unitNumber" element={<UnitDetailsPage />} />
            <Route path="/location" element={<LocationPage />} />
            <Route path="/virtual-tour" element={<VirtualTourPage />} />
            <Route path="/gallery" element={<GalleryMasterPage />} />
            <Route path="/gallery-internal/" element={<GalleryInternalPage />} />
            <Route path="/videos" element={<VideosPage />} />
        </Routes>
    );
}

export default RoutesPage;
